import {
  CloseFullscreen,
  InfoOutlined,
  OpenInFullOutlined,
} from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  IconButton,
  Modal,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import ReactWordcloud from "react-wordcloud";
import {
  useRedditWordCloud,
  useTwitterWordCloudData,
} from "../../../lib/hooks";
import { toShortNumber } from "../../../lib/util";
import styles from "./../../../styles/charts/chartStyle.module.css";
import { PieChartLoading } from "../protoCharts/PieChart";
import "tippy.js/dist/tippy.css";

import "tippy.js/animations/scale.css";
import {
  listing_options,
  post_catergory_options,
  time_filter_options,
} from "../../../lib/twitterAPI";
import { desc } from "../../../lib/chartDescription";
import React from "react";
import {
  getChartBottomIcons,
  getChartInfoIcons,
} from "../twitter/TwitterWordCloud";

export default function RedditWordCloud() {
  let words: any[] = [];
  const [postCategory, setpostCategory] = useState(post_catergory_options[0]);

  const [timeFilter, settimeFilter] = useState(time_filter_options[0]);

  const [listing, setListing] = useState(listing_options[0]);

  const { wordCloudData, loading, error } = useRedditWordCloud({
    post_category: postCategory,
    time_filter: timeFilter,
    listing,
  });

  !loading &&
    error === null &&
    wordCloudData.forEach((item) => {
      words.push({
        text: item.word,
        value: item.count,
      });
    });

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const callbacks = {
    // disabled tool tip for now, but planned to find a way to add the tool tip with a nice background color so that it will look good
    getWordTooltip: (word: { text: any; value: number }) =>
      `${word.text}(${toShortNumber(word.value)})`,
  };

  const content = (showMaxButton: boolean) => {
    return (
      <Paper elevation={3} className={styles.chartContainer}>
        <div className="horizontalCenter">
          <Typography className={styles.chartHeader}>Word Cloud</Typography>
        </div>
        <div className="horizontalCenter">
          <div className={styles.selectOptionRowWordCloud}>
            <Autocomplete
              // autoComplete
              id="combo-box-demo"
              fullWidth
              options={post_catergory_options}
              // isOptionEqualToValue={(option, value) => option.label === value}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: string | null) => {
                // setValue(newValue);
                setpostCategory(newValue as string);
                // console.log(newValue);
              }}
              disableClearable
              value={postCategory as string}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // can be used to style  input later on
                  // InputProps={{ style: { fontSize: 14 } }}
                  label="Post Category"
                />
              )}
            />
            {["Controversial Posts", "Top Posts", "Keyword Posts"].includes(
              postCategory
            ) && (
              <Autocomplete
                // autoComplete
                fullWidth
                id="combo-box-demo"
                options={time_filter_options}
                // isOptionEqualToValue={(option, value) => option.label === value}
                // sx={{ width: "40%" }}
                sx={{ width: "220px" }}
                size={"small"}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  settimeFilter(newValue as string);
                  // console.log(newValue);
                }}
                disableClearable
                value={timeFilter as string}
                renderInput={(params) => (
                  <TextField {...params} label="Time Filter" />
                )}
              />
            )}
            {"Keyword Posts" === postCategory && (
              <Autocomplete
                // autoComplete
                fullWidth
                id="combo-box-demo"
                options={listing_options}
                // isOptionEqualToValue={(option, value) => option.label === value}
                // sx={{ width: "40%" }}
                sx={{ width: "220px" }}
                size={"small"}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  setListing(newValue as string);
                  // console.log(newValue);
                }}
                disableClearable
                value={listing as string}
                renderInput={(params) => (
                  <TextField {...params} label="Listing" />
                )}
              />
            )}
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <>
            {loading && (
              <Box className={styles.center}>
                <PieChartLoading />
              </Box>
            )}
            {!loading && (
              <ReactWordcloud
                callbacks={callbacks}
                words={words}
                options={{
                  fontSizes: [10, 50],
                  rotations: 0,
                  enableOptimizations: true,
                }}
              />
            )}
          </>
          {getChartBottomIcons(showMaxButton, setOpen)}
          {getChartInfoIcons(desc["reddit"]["wordCloud"])}
        </div>
      </Paper>
    );
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.fullScreenChart}>{content(false)}</Box>
      </Modal>
      {content(true)}
    </>
  );
}
